import React from 'react';
import { Paper, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  card: { padding: 18, height: '100%', boxSizing: 'border-box' },
  title: { fontSize: 15, fontWeight: 600, color: '#374151', marginBottom: 12 },
  // Horizontal scroll so wide tables don't overflow the card on small screens.
  body: { width: '100%', overflowX: 'auto' },
}));

type Props = { title: string; children: React.ReactNode };

const ChartCard: React.FC<Props> = ({ title, children }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.card} elevation={1}>
      <Typography className={classes.title}>{title}</Typography>
      <div className={classes.body}>{children}</div>
    </Paper>
  );
};

export default ChartCard;
